import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { getListOfSubcategoriesforFolderViewQuery, getSubcategoryListQuery } from "../../../services/graphql/queries/category-management";

import { errorMessage } from "../../../miscellaneous/error-messages";
import { errorMsg } from "../../../miscellaneous/react-toastify";
import BreadCrumb from "./SubcategoryBreadcrumb";

class SubcategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: [],
      subcategories: [],
    };
  }

  getListOfSubcategory() {
    this.setState({ loading: true });
    // let subcategoryLevel = 1, referenceId = 0;
    // if(this.props.breadCrumbArr.length){
    //     subcategoryLevel = this.props.breadCrumbArr.length;
    // }
    // if(this.props.breadCrumbArr.length > 1){
    //     referenceId = this.props.category.id
    // }
    // var category = localStorage.getItem('categoryId');
    // category = JSON.parse(category);
    let subcategoryLevel = 1,
      referenceId = 0,
      categoryId = 0;
    if (this.props.category.isCategory) {
      subcategoryLevel = 1;
      referenceId = 0;
      categoryId = this.props.category.id;
    } else {
      subcategoryLevel = 2;
      referenceId = this.props.category.id;
      categoryId = this.props.category.categoryId.id;
    }
    this.props.client
      .query({
        query: getListOfSubcategoriesforFolderViewQuery,
        variables: {
          referenceId: referenceId,
          categoryId: categoryId,
          subcategoryLevel: subcategoryLevel,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var subcategories = result.data.getListOfSubcategoriesforFolderView;

        this.initialState = {
          subcategories: subcategories,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  // getListOfSubcategory() {
  //   this.setState({ loading: true });
  //   this.props.client
  //     .query({
  //       query: getListOfSubcategoriesforFolderViewQuery,
  //       variables: {
  //         referenceId: this.props.referenceId,
  //         categoryId: this.props.category,
  //         subcategoryLevel: this.props.subcategoryLevel + 1,
  //       },
  //       fetchPolicy: "network-only",
  //     })
  //     .then((result) => {
  //       var subcategories = result.data.getListOfSubcategoriesforFolderView;

  //       this.initialState = {
  //         subcategories: subcategories,
  //       };
  //       this.setState({ ...this.initialState, loading: false, error: "" });
  //     })
  //     .catch((error) => {
  //       this.setState({ loading: false, error: error.message });
  //     });
  // }

  onUpdateSubcategory(subcategory) {
    this.props.onUpdateSubcategory(subcategory);
  }

  componentDidMount() {
    this.getListOfSubcategory();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category) {
      this.getListOfSubcategory();
    }
  }

  render() {
    const { loading, errors, subcategories } = this.state;
    return (
      <div className="box-card" style={{ minHeight: "100%", marginTop: "0px" }}>
        <div id="subCatList">
          <div className="row align-items-center no-gutters">
            <div className="col-md-8">
              <h1 className="heading m-b-0">Folder/Sub-Folder List</h1>
            </div>
            <div className="table-responsive">
              <table className="table table-style-1">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">NAME</th>
                    <th scope="col">DESCRIPTION</th>
                  </tr>
                </thead>
                <tbody>
                  {subcategories.length
                    ? subcategories.map((subcategory, index) => {
                        return (
                          <tr
                            key={index}
                            onClick={() =>
                              this.onUpdateSubcategory(subcategory)
                            }
                          >
                            <td>{subcategory.id}</td>
                            <td>{subcategory.name}</td>
                            <td>{subcategory.description}</td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(withApollo(SubcategoryList)));
